module.exports = __webpack_public_path__ + "static/media/message-inbox-loyalty-promo.67a2c678.png";